import React from 'react';
import {API_URL} from '../index';
import Dialog from '@material-ui/core/Dialog';
import { useState, useRef, useEffect } from 'react';
import EditIcon from '@material-ui/icons/Edit'
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {Grid, Paper, Divider} from '@material-ui/core'
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PersonIcon from '@material-ui/icons/Person';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { blue } from '@material-ui/core/colors';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Container from '@material-ui/core/Container';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputLabel from '@material-ui/core/InputLabel';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import CloseIcon from '@material-ui/icons/Close';
import Select from 'react-select';
import Docs from './Docs';
import NewDoc from './NewDoc';
import DeleteOrganisationDialog from './DeleteOrganisationDialog';
import Fade from '@material-ui/core/Fade';


const useStyles = makeStyles(theme => ({

  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    width: 150,
  },

}));

function Confirm(props) {

  const [fetching, setFetching] = useState(false);
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState();

  const handleClose = () => {
    setOpen(false);
  }

  const sendToSpecify = () => {
    setFetching(true)
    const token = localStorage.getItem('token');
    const org_url = API_URL + 'org_edit/' + props.organisation_id + '/'
    const org = {
            "archive_spec": props.archive.value
          }
      fetch(org_url, {
        method: 'PATCH',
        body: JSON.stringify(org),
        headers: { 'Authorization': 'Token ' + (token), 'Content-Type': 'application/json' }
      })
      .then(response => 
        (response.status == 400 ?
          response.json().then(data =>
            setResponse(data)) :
          response.json().then(data =>
            setResponse(data))
          .then(e => (props.handleClose(), props.handleCloseOrg(), props.refresh()))
          .then(e => handleClose())
          .then(e => console.log(response))
          )
        )
  }

  return(
      <React.Fragment>
      <Button color="primary" onClick={() => setOpen(true)}>
        Отправить
      </Button>
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth maxWidth='xs'>
      <DialogTitle id="simple-dialog-title">На уточнение
      <Tooltip title='Закрыть' placement='left-end' style={{float: 'right'}}>
        <IconButton onClick={handleClose}>
          <CloseIcon/>
        </IconButton>
      </Tooltip>
      </DialogTitle>
        <DialogContent>
          <DialogContentText>
          <Typography variant="caption" display="block" gutterBottom>
            {'Отправить на уточнение в ' + props.archive.label + '?' }
          </Typography>
          <Typography variant="body1" gutterBottom>
          {props.title}
          </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button style={{color: 'red'}} onClick={() => sendToSpecify()}>
            Отправить
          </Button>
          <Button color="primary" onClick={handleClose}>
            Отмена
          </Button>
        </DialogActions>
      </Dialog>
      </React.Fragment>
    )
}

export default function Specify(props) {
  const classes = useStyles();

  const [fetching, setFetching] = useState(false);
  const [title, setTitle] = useState();
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState();
  const [archives, setArchives] = useState();
  const [archive, setArchive] = useState();


  useEffect(() => {
    setToken(localStorage.getItem('token'));
    const archives_url = API_URL + 'archives/'

    fetch(archives_url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => response.json())
      .then(data => data.results.map(archive => ({
                      value: archive.id,
                      label: archive.title_short,
                    })))
      .then(data => setArchives(data))
  }, []);

  const handleChangeArchiveLS = archive => {
      setArchive(archive);
    }

  const handleClose = () => {
    setOpen(false);
    setArchive(null);
  }

  return (
    <React.Fragment>
          <Button color="default" onClick={() => setOpen(true)} disabled={props.disabled}>
            На уточнение
          </Button>
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth maxWidth='md'>
      <DialogTitle id="simple-dialog-title">{'Отправить #' + props.organisation.id + ' на уточнение:'}
      <Tooltip title='Закрыть' placement='left-end' style={{float: 'right'}}>
        <IconButton onClick={handleClose}>
          <CloseIcon/>
        </IconButton>
      </Tooltip>
      </DialogTitle>
        <DialogContent>
          <DialogContentText>
          <InputLabel>Укажите архив:</InputLabel>
            <Select
              native
              value={archive}
              onChange={handleChangeArchiveLS}
              options={archives}
              placeholder="Архив"
            />
          </DialogContentText>
        <Typography variant="h6" gutterBottom>
          Направление на уточнение
        </Typography>
        <Typography variant="caption" display="block" gutterBottom>
          Запись о следующей организации:
        </Typography>
        <Typography variant="body1" gutterBottom>
          {props.organisation.title}
        </Typography>
        <Typography variant="caption" display="block" gutterBottom>
          будет направлена в выбранное архивное учреждение для
          уточнение фактического места нахождения документов
          по личному составу
        </Typography>
        </DialogContent>
        <DialogActions>
          {archive != undefined ?
          <Confirm title={props.organisation.title} archive={archive} organisation_id={props.organisation.id}
                    handleClose={() => handleClose()} handleCloseOrg={() => props.handleClose()} refresh={() => props.refresh()}/>
          :
          <Button color="primary" disabled>
            Отправить
          </Button>
          }
          <Button color="secondary" onClick={handleClose}>
            Отмена
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}